export const TEXTS = {
  MODAL_TITLE: 'Оплатите и заиграет музыка',
  MODAL_DESCRIPTION_DEVICE: 'Устройство привязано к адресу. Музыка зазвучит в вашем плеере после оплаты:',
  MODAL_DESCRIPTION_STREAM: 'Волна привязана к адресу. Музыка зазвучит в вашем плеере после оплаты:',
  MODAL_BUTTON_SUBMIT: 'Перейти к оплате',
};
